export default "/_next/static/images/Artdeco-28f7fb53880b663aae655da5b989cd1d.png";